import { useState, useContext } from 'react';
import { useIntl } from 'react-intl';
import { NotificationsContext } from '../../../../../context/NotificationsContext';
import dayjs from 'dayjs';
import { downloadFullXlsx } from '../../../../../services/api/deliveryNote';

const useDownloadXlsxFile = (
  { id_project, work_code },
  concreteType = 'RC',
) => {
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  const { pushNotification } = useContext(NotificationsContext);

  const handleDownloadXlsx = async () => {
    setLoading(true);
    try {
      const response = await downloadFullXlsx(id_project);

      if (!response || !response.data) {
        throw new Error(
          intl.formatMessage({ id: 'downloadXlsx.error.noData' }),
        );
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `${work_code}_INFOALBARAN_${dayjs().format('YYYYMMDD')}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error al descargar el archivo Xlsx:', err);

      let errorMessage;

      if (!err.response && !err.request) {
        errorMessage = err.message;
      } else {
        errorMessage = intl.formatMessage({ id: 'downloadXlsx.error.generic' });
      }

      pushNotification({
        type: 'error',
        message: errorMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  return { downloadXlsx: handleDownloadXlsx, loading };
};

export default useDownloadXlsxFile;
